module.exports = __webpack_public_path__ + "media/images/features/refund/icon-question-2ec8ff1e0d4c40c08c5762e3b7f2df48.svg";